import {
  useRef,
  useState
} from "react";

type Request = (
  route: string,
  method?: string,
  body?: unknown
) => Promise<any>;

export function CorpusCompleteness({
  request
}: {
  request: Request
}) {
  const [data, setData] =
    useState<any>(null);

  const [task, setTask] =
    useState<any>(null);

  const [pending, setPending] =
    useState(false);

  const [error, setError] =
    useState("");

  const serial =
    useRef(0);

  const load = async () => {
    const n = ++serial.current;

    setPending(true);
    setError("");

    try {
      const value =
        await request(
          "/corpus-completeness"
        );

      if (n === serial.current) {
        setData(value);
      }
    } catch (cause) {
      setError(
        cause instanceof Error
          ? cause.message
          : String(cause)
      );
    } finally {
      if (n === serial.current) {
        setPending(false);
      }
    }
  };

  const prepare = async () => {
    setPending(true);
    setError("");

    try {
      const value =
        await request(
          "/corpus-completeness/prepare",
          "POST",
          {}
        );

      setTask(value);
    } catch (cause) {
      setError(
        cause instanceof Error
          ? cause.message
          : String(cause)
      );
    } finally {
      setPending(false);
    }
  };

  return (
    <details
      className="panel"
      onToggle={event => {
        if (
          event.currentTarget.open &&
          !data
        ) {
          void load();
        }
      }}
    >
      <summary>
        Corpus completeness · re-explore prior research
      </summary>

      <p>
        Recheck the complete canonical research corpus for
        missing Case assessments, central people and companies,
        reusable Entities and Concepts, and missing canonical
        relationships. Research and Proposal review remain
        mandatory.
      </p>

      {error && (
        <p
          className="alert"
          role="alert"
        >
          {error}
        </p>
      )}

      {pending && (
        <p role="status">
          Preparing…
        </p>
      )}

      {data && (
        <>
          <p>
            Revision {data.knowledge_revision} ·{" "}
            {data.total_scoped_records} scoped records ·{" "}
            {data.case_count} Cases ·{" "}
            {data.cases_without_assessment_profile} Cases
            without assessment profiles ·{" "}
            {data.existing_entity_count} existing Entities
          </p>

          <details>
            <summary>
              Corpus by kind
            </summary>
            <pre>
              {JSON.stringify(
                data.by_kind,
                null,
                2
              )}
            </pre>
          </details>

          <p className="muted">
            Missing Entities cannot be counted safely by name
            matching; the Enrich research pass discovers them
            from evidence and canonical context.
          </p>

          <button
            className="primary"
            disabled={pending}
            onClick={() =>
              void prepare()
            }
          >
            Prepare corpus completeness Enrich
          </button>
        </>
      )}

      {task && (
        <p className="notice">
          Corpus-wide Enrich prepared.{" "}
          <a
            href={`#workstream=${task.workstream_id}`}
          >
            Open Historical corpus completeness
          </a>
          . No canonical knowledge or publication state was
          changed.
        </p>
      )}
    </details>
  );
}
